import { useMemo, useState } from 'react';

export const useFilteredOptions = (options, search, step) => {
  const [visibleCount, setVisibleCount] = useState(step);

  const toSearchableString = (str) => String(str)?.toLowerCase() || '';
  const isValidOption = (opt) => Boolean(opt.label || opt.value);

  const filteredOptions = useMemo(() => {
    const searchStr = toSearchableString(search);
    return options
      .map((group) => {
        const filteredInGroup = group.options
          .filter(isValidOption)
          .filter((opt) => {
            const labelMatch = toSearchableString(opt.label).includes(searchStr);
            const valueMatch = toSearchableString(opt.value).includes(searchStr);
            return labelMatch || valueMatch;
          });
        return filteredInGroup.length ? { ...group, options: filteredInGroup } : null;
      })
      .filter(Boolean);
  }, [options, search]);

  const visibleOptions = useMemo(() => {
    let shown = 0;
    return filteredOptions.reduce((acc, group) => {
      if (shown >= visibleCount) return acc;

      const remaining = visibleCount - shown;
      const visibleInGroup = group.options.slice(0, remaining);
      shown += visibleInGroup.length;

      if (visibleInGroup.length > 0) {
        acc.push({ ...group, options: visibleInGroup });
      }

      return acc;
    }, []);
  }, [filteredOptions, visibleCount]);

  const totalVisibleCount = filteredOptions.reduce((acc, group) => acc + group.options.length, 0);
  const canShowMore = visibleCount < totalVisibleCount;

  const handleShowMore = () => setVisibleCount((c) => c + step);

  return { visibleOptions, canShowMore, handleShowMore };
};
